module.exports = __webpack_public_path__ + "img/ronald.b252bd88.png";